import { render, staticRenderFns } from "./AdminBookingFileLog.vue?vue&type=template&id=0f01d783"
import script from "./AdminBookingFileLog.vue?vue&type=script&lang=js"
export * from "./AdminBookingFileLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports